import React, {  useEffect, useState, useCallback } from 'react';
import { useSelector } from "react-redux"; 
import { useDispatch } from "react-redux"; 
import { useTranslation } from "react-i18next"  
import { useNavigate } from 'react-router-dom'; 
import { ENDPOINT } from "constants/variables"; 
import Box from '@mui/material/Box'; 
import CircularProgress from '@mui/material/CircularProgress';  
import TextField from '@mui/material/TextField';
import { helpHttp } from "service/HelpHttp";
import { setLoading } from 'reducers/loadingSlice';
import { LoadingNews } from "components/utils/LoadingNews";
import { successErrorAction,warningErrorAction } from "actions/ErrorActions"; 
import "css/generalSettings.css";
import "css/customDialog.css";         
import PropTypes from 'prop-types';  
import TableSortingNormalizedWorkPlace from "pages/purchaseDelivery/purchaseDeliveryNormalized/SortingTablesPurchaseNormalized";
  
const initialStateNormalized = [{
  "id":"",
  "indexrow":0, 
  "ori_tras_store_id":0,
  "ori_tras_tradename":"",
  "normalizedworkplace":"",
  "newnormalizedworkplace":"",
  "enablednormalizedworkplace":false,
  "error":false
}];  
 
const infoData = {
  "id":"",
  "ori_tras_store_id":0, 
  "ori_tras_tradename":"", 
};  

const PurchaseDeliveryNormalized = ({id, showModalPurchasesNormalized,typeOfList}) => {
  const {t} = useTranslation(['listDataPurchases']);
  const token = useSelector((state) => state.loginUser.token);   
  const LIMITPAGESIZE = useSelector((state) => state.loginUser.defaultticketsformat.limitpagesize);
  const dispatch = useDispatch();
  const navigate = useNavigate();  
  const isLoadingData = useSelector((state) => state.loading.isLoading);
  const [formInfoData, setFormInfoData] = useState(infoData);
  const [formNormalized, setFormNormalized] = useState(initialStateNormalized);
  const [inputTextPurchaseNormalized, setInputTextPurchaseNormalized] = useState("");  
   
  const keyPress = useCallback(
    e => {
      if (e.key === 'Escape' && showModalPurchasesNormalized) {
        dispatch(setLoading(false));   
        setFormNormalized(initialStateNormalized);
        setFormInfoData(infoData);
        setInputTextPurchaseNormalized(""); 
        navigate(typeOfList==="1"?"/purchasedelivery":typeOfList==="2"?"/purchasedeliveryended":"/purchasedeliverybegin");
      }
    },
    [ 
      showModalPurchasesNormalized, 
      setFormNormalized,
      setFormInfoData,
      setInputTextPurchaseNormalized,
      typeOfList,
      dispatch,
      navigate]
  );
  
  const handleCloseNormalizedPurchase = () => {
    dispatch(setLoading(false)); 
    setFormNormalized(initialStateNormalized);
    setFormInfoData(infoData);
    setInputTextPurchaseNormalized(""); 
    navigate(typeOfList==="1"?"/purchasedelivery":typeOfList==="2"?"/purchasedeliveryended":"/purchasedeliverybegin");
	}; 

  const filteredDataPurchaseNormalized = formNormalized.filter((el) => {
    if (inputTextPurchaseNormalized === '') { 
      return el;
    }
    else {
      let dataTranslate = 
      String(el.normalizedworkplace || '') ;
      let result = dataTranslate.toLowerCase().includes(inputTextPurchaseNormalized.toLowerCase());
      return result;
    } 
  }) 

  let inputHandlerPurchaseNormalized  = (e) => {
    var lowerCase = e.target.value.toLowerCase();
    setInputTextPurchaseNormalized(lowerCase);
};
 
  const handleSubmitNormalizedWorkPlace =  async ()=>{
    const regexInvalidCharacters = /[\\!$%&|<>?{}~"']/;
    const hasEmptyValues = formNormalized.some(row => !row.newnormalizedworkplace.trim());
    const hasInvalidCharacters = formNormalized.some(row => regexInvalidCharacters.test(row.newnormalizedworkplace));
    if (!hasEmptyValues && !hasInvalidCharacters && formNormalized && formNormalized.length > 0) {
      handleCloseNormalizedPurchase();
      const fetchData = async () => {
        let isMounted = true;
        try {
          const getData = await helpHttp().post(ENDPOINT, `purchasenormalized/savepurchasenormalizedworkplace`, token, formNormalized) 
          if (getData.status === "OK") { 
            dispatch(successErrorAction(t('Text_SaveData'))); 
          } else {
            if (isMounted ) {
              dispatch(warningErrorAction(t(getData.cause)));
            }
          }
        } catch (error) {
          dispatch(warningErrorAction(t('Text_IncorrectData'))); 
        }
        return () => { isMounted = false;};
      };
      fetchData();
    } else { 
      if (hasEmptyValues) {
        dispatch(warningErrorAction(t('Text_Error_New_Normalizedworkplace')));
      } else if (hasInvalidCharacters) {
        dispatch(warningErrorAction(t('Text_TextNoValid')));
      } else {
        dispatch(warningErrorAction(t('Text_IncorrectData')));
      }
    }
  };  
  
  useEffect(() => {
    const handleKeyPress = (event) => {
      if (event && typeof event === 'object' && event.key) {
        keyPress(event);
      }
    };
    document.addEventListener('keydown', handleKeyPress);
    return () => {
      document.removeEventListener('keydown', handleKeyPress);
    };
  }, [keyPress]);

  useEffect(() => {
    let isMounted = true;

    const fetchDataPurchaseInfoData= async () => {
      dispatch(setLoading(true));
      try {
        const getData = await  helpHttp().get2(ENDPOINT,`purchasenormalized/getpurchasnormalizedinfodata/`,token,id);
        if (getData.err) {
          setFormInfoData(infoData); 
          dispatch(setLoading(false));
          dispatch(warningErrorAction(t(getData.message === "Load failed" ? 'Text_ConnectionFailied' : 'Text_InvalidCredentials')));
        } else if (isMounted) {
          setFormInfoData(getData); 
          dispatch(setLoading(false));
        }  
      } catch (error) {
        dispatch(setLoading(false));
        dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      }  
    };

    const fetchDataPurchaseNormalized = async () => {
      dispatch(setLoading(true));
      try {
        const getData = await  helpHttp().get2(ENDPOINT,`purchasenormalized/getpurchasnormalizedlist/`,token,formInfoData.ori_tras_store_id);
        if (getData.err) {
          setFormNormalized(initialStateNormalized); 
          dispatch(setLoading(false));
          dispatch(warningErrorAction(t(getData.message === "Load failed" ? 'Text_ConnectionFailied' : 'Text_InvalidCredentials')));
        } else if (isMounted) { 
          setFormNormalized(getData); 
          dispatch(setLoading(false));
        }  
      } catch (error) {
        dispatch(setLoading(false));
        dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      }  
    };

    if (id!=="0"){
      if (formInfoData.id===""){ 
        fetchDataPurchaseInfoData(); 
        dispatch(setLoading(false)); 
      }        
    }else{
      setFormInfoData(infoData);
      dispatch(setLoading(false));
    }
    if (formInfoData.ori_tras_store_id && formInfoData.ori_tras_store_id!=="" && formInfoData.ori_tras_store_id!=="0" && formInfoData.ori_tras_store_id!==0){
      fetchDataPurchaseNormalized();
      dispatch(setLoading(false)); 
    } else{
      setFormNormalized(initialStateNormalized);
      dispatch(setLoading(false));
    }

    return () => { isMounted = false };
  }, [dispatch,id,t,token,formInfoData.id,formInfoData.ori_tras_store_id]);  
 
  return (
    <>
      {showModalPurchasesNormalized ? ( 
        <div className="container-fluid email-send-wrapper">
          <Box sx={{ bgcolor: '#ffffff', width: '1600px' }}>
            <form onSubmit={handleCloseNormalizedPurchase}>
              {/* HEADER */}
              <div className="email-card-header">
                <div className="email-header-content">
                  <div className="email-header-icon">
                    {(isLoadingData?
                      <CircularProgress sx={{ color : "#f6c23e"}}/>: 
                      <i className="fas fa-solid fa-map-pin text-primary"></i>)
                    }             
                  </div>
                  <div className="email-header-text">
                    <div className="email-header-title">
                      {t('Text_NORMALIZED')}:
                    </div>
                    <div className="email-header-number">
                      {formInfoData.ori_tras_tradename}
                    </div>
                  </div>
                  <div className="email-card-actions">
                    {!isLoadingData && (
                      <>
                        <button type="button" className="email-send-btn" onClick={handleSubmitNormalizedWorkPlace} >
                          {t('Button_NORMALIZED_WORKPLACE')} 
                        </button>
                        <button type="button" className="email-cancel-btn" onClick={handleCloseNormalizedPurchase} >
                          {t('Button_Cancel')}
                        </button>
                      </>
                    )}
                  </div>
                </div>
              </div> 
              <br/>
               {/* HEADER */}
              <div className="email-card-header">
                <div className="email-header-content">
                  <div className="email-header-text">
                    <div className="email-header-title text-justify">
                        {t('Text_INFO')}
                    </div> 
                  </div> 
                </div>
              </div> 
              <br/>   
              {/* Buscador */}
              <div className="formdi-pending-search">
                <TextField
                  id="outlined-basic"
                  variant="outlined"
                  value={inputTextPurchaseNormalized}
                  inputProps={{ style: {fontSize: '18px'} }}
                  InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}} 
                  placeholder={t('Text_PurchaseDelivery_Search_Normalized')} 
                  onChange={inputHandlerPurchaseNormalized }
                  fullWidth
                  label={t('Text_PurchaseDelivery_Search_Normalized')}>
                </TextField>
              </div>
              <br/>
              {!isLoadingData ?
                <>
                  <div className="formdi-pending-card-flat">
                    <div className="formdi-pending-card-content"> 
                      <TableSortingNormalizedWorkPlace
                        dataNormalized={filteredDataPurchaseNormalized}
                        setFormNormalized={setFormNormalized}
                        LIMITPAGESIZE={LIMITPAGESIZE}
                        >
                      </TableSortingNormalizedWorkPlace>
                    </div>
                  </div>  
                </>:
                  <LoadingNews/>
                } 
              </form>
            </Box>
           
            <br/>
          </div>
        //* End Page Content *//
      ) :  null }
    </>
  )    
}

PurchaseDeliveryNormalized.propTypes = {
  id: PropTypes.string.isRequired,
  showModalPurchasesNormalized: PropTypes.bool.isRequired
};

export default PurchaseDeliveryNormalized;